import { useFormikContext } from 'formik';
import React, { useState } from 'react';
import { FaWindowClose } from 'react-icons/fa';
import * as R from 'ramda';

import NavTabs from 'App/components/NavTabs/NavTabs';
import InsuranceFormArea from 'App/components/PatientInsurance/InsuranceFormArea';
import TherigyInfoMessage from 'App/components/TherigyInfoMessage/TherigyInfoMessage';
import CommonPatientFieldWrapper from 'App/components/PatientForm/components/CommonPatientFieldWrapper';

import SectionTitleStyle from 'App/components/PatientForm/components/SectionTitleStyle';
import RequiredAsterisk from 'Shared/form/RequiredAsterisk';
import AttachInsurancePlan from './AttachInsurancePlan';
import DetachInsuranceModal from './DetachInsuranceModal';
import { Button } from 'react-bootstrap';

const shouldShowModal = (index) => {
    return R.is(Number, index) && index >= 0;
};

function BenefitsInvestigationInsuranceForm() {
    const formik = useFormikContext();

    const { values, setValues, validateForm } = formik;
    const [indexToRemove, setIndexToRemove] = useState(null);

    const removeInsurancePlan = (index) => {
        R.compose(setValues, R.over(R.lensProp('patientInsurance'), R.remove(index, 1)))(values);

        setIndexToRemove(null);
        setImmediate(() => validateForm());
    };

    return (
        <CommonPatientFieldWrapper fieldName="referralBiInsurancePlans">
            {(commonProps) => {
                const isSectionDisabled = commonProps.disabled || values.disableInputs;
                const isSectionRequired = commonProps.required;
                const hasInsuranceError = isSectionRequired && !values.patientInsurance.length;

                return (
                    <>
                        <SectionTitleStyle>
                            <h2 style={isSectionRequired ? { fontWeight: 'bold' } : undefined}>
                                Insurance Plans
                                {isSectionRequired && <RequiredAsterisk />}
                            </h2>
                        </SectionTitleStyle>

                        {!isSectionDisabled && <AttachInsurancePlan />}
                        {!values.patientInsurance.length ? (
                            <>
                                <TherigyInfoMessage message="There are no insurance plans attached to this patient." />
                                {hasInsuranceError && (
                                    <div className="help-block has-error">
                                        <span className="error-message-insurance text-danger">
                                            At least one insurance plan is required.
                                        </span>
                                    </div>
                                )}
                            </>
                        ) : (
                            <div data-testid="bi-insurance-tabs">
                                <NavTabs
                                    items={values.patientInsurance}
                                    renderNavTab={(item, index) => {
                                        const name = item.name || `Plan ${item.position}`;
                                        return (
                                            <>
                                                <span>{name}</span>
                                                {!isSectionDisabled && !values.disableInputs && (
                                                    <Button
                                                        aria-label={`Detach ${name}`}
                                                        size="xs"
                                                        variant="link"
                                                        onClick={() => {
                                                            setIndexToRemove(index);
                                                        }}
                                                    >
                                                        <FaWindowClose />
                                                    </Button>
                                                )}
                                            </>
                                        );
                                    }}
                                    renderPaneContent={(item, index) => (
                                        <InsuranceFormArea
                                            fieldPrefix={`patientInsurance[${index}]`}
                                            isBenefitsInsurance
                                            insuranceId={item.id}
                                            disabled={isSectionDisabled}
                                        />
                                    )}
                                />
                            </div>
                        )}
                        {shouldShowModal(indexToRemove) && (
                            <DetachInsuranceModal
                                onHide={() => {
                                    setIndexToRemove(null);
                                }}
                                onConfirm={() => removeInsurancePlan(indexToRemove)}
                            />
                        )}
                    </>
                );
            }}
        </CommonPatientFieldWrapper>
    );
}

export default BenefitsInvestigationInsuranceForm;
